import C2 from "./steinway-piano/C2.mp3";
import Db2 from "./steinway-piano/Db2.mp3";
import D2 from "./steinway-piano/D2.mp3";
import Eb2 from "./steinway-piano/Eb2.mp3";
import E2 from "./steinway-piano/E2.mp3";
import F2 from "./steinway-piano/F2.mp3";
import Gb2 from "./steinway-piano/Gb2.mp3";
import G2 from "./steinway-piano/G2.mp3";
import Ab2 from "./steinway-piano/Ab2.mp3";
import A2 from "./steinway-piano/A2.mp3";
import Bb2 from "./steinway-piano/Bb2.mp3";
import B2 from "./steinway-piano/B2.mp3";

import C3 from "./steinway-piano/C3.mp3";
import Db3 from "./steinway-piano/Db3.mp3";
import D3 from "./steinway-piano/D3.mp3";
import Eb3 from "./steinway-piano/Eb3.mp3";
import E3 from "./steinway-piano/E3.mp3";
import F3 from "./steinway-piano/F3.mp3";
import Gb3 from "./steinway-piano/Gb3.mp3";
import G3 from "./steinway-piano/G3.mp3";
import Ab3 from "./steinway-piano/Ab3.mp3";
import A3 from "./steinway-piano/A3.mp3";
import Bb3 from "./steinway-piano/Bb3.mp3";
import B3 from "./steinway-piano/B3.mp3";

import C4 from "./steinway-piano/C4.mp3";
import Db4 from "./steinway-piano/Db4.mp3";
import D4 from "./steinway-piano/D4.mp3";
import Eb4 from "./steinway-piano/Eb4.mp3";
import E4 from "./steinway-piano/E4.mp3";
import F4 from "./steinway-piano/F4.mp3";
import Gb4 from "./steinway-piano/Gb4.mp3";
import G4 from "./steinway-piano/G4.mp3";
import Ab4 from "./steinway-piano/Ab4.mp3";
import A4 from "./steinway-piano/A4.mp3";
import Bb4 from "./steinway-piano/Bb4.mp3";
import B4 from "./steinway-piano/B4.mp3";

import C5 from "./steinway-piano/C5.mp3";
import Db5 from "./steinway-piano/Db5.mp3";
import D5 from "./steinway-piano/D5.mp3";
import Eb5 from "./steinway-piano/Eb5.mp3";
import E5 from "./steinway-piano/E5.mp3";
import F5 from "./steinway-piano/F5.mp3";
import Gb5 from "./steinway-piano/Gb5.mp3";
import G5 from "./steinway-piano/G5.mp3";
import Ab5 from "./steinway-piano/Ab5.mp3";
import A5 from "./steinway-piano/A5.mp3";
import Bb5 from "./steinway-piano/Bb5.mp3";
import B5 from "./steinway-piano/B5.mp3";

import C6 from "./steinway-piano/C6.mp3";
import Db6 from "./steinway-piano/Db6.mp3";
import D6 from "./steinway-piano/D6.mp3";
import Eb6 from "./steinway-piano/Eb6.mp3";
import E6 from "./steinway-piano/E6.mp3";
import F6 from "./steinway-piano/F6.mp3";
import Gb6 from "./steinway-piano/Gb6.mp3";
import G6 from "./steinway-piano/G6.mp3";
import Ab6 from "./steinway-piano/Ab6.mp3";
import A6 from "./steinway-piano/A6.mp3";
import Bb6 from "./steinway-piano/Bb6.mp3";
import B6 from "./steinway-piano/B6.mp3";

// TODO generate all mp3s (macro for audacity/adobe audition?)
// See: http://theremin.music.uiowa.edu/MISpiano.html#

const SteinwayPiano = {
  C2: String(C2),
  Db2: String(Db2),
  D2: String(D2),
  Eb2: String(Eb2),
  E2: String(E2),
  F2: String(F2),
  Gb2: String(Gb2),
  G2: String(G2),
  Ab2: String(Ab2),
  A2: String(A2),
  Bb2: String(Bb2),
  B2: String(B2),

  C3: String(C3),
  Db3: String(Db3),
  D3: String(D3),
  Eb3: String(Eb3),
  E3: String(E3),
  F3: String(F3),
  Gb3: String(Gb3),
  G3: String(G3),
  Ab3: String(Ab3),
  A3: String(A3),
  Bb3: String(Bb3),
  B3: String(B3),

  C4: String(C4),
  Db4: String(Db4),
  D4: String(D4),
  Eb4: String(Eb4),
  E4: String(E4),
  F4: String(F4),
  Gb4: String(Gb4),
  G4: String(G4),
  Ab4: String(Ab4),
  A4: String(A4),
  Bb4: String(Bb4),
  B4: String(B4),

  C5: String(C5),
  Db5: String(Db5),
  D5: String(D5),
  Eb5: String(Eb5),
  E5: String(E5),
  F5: String(F5),
  Gb5: String(Gb5),
  G5: String(G5),
  Ab5: String(Ab5),
  A5: String(A5),
  Bb5: String(Bb5),
  B5: String(B5),

  C6: String(C6),
  Db6: String(Db6),
  D6: String(D6),
  Eb6: String(Eb6),
  E6: String(E6),
  F6: String(F6),
  Gb6: String(Gb6),
  G6: String(G6),
  Ab6: String(Ab6),
  A6: String(A6),
  Bb6: String(Bb6),
  B6: String(B6),
};

export const lowestSupportedNote = "C2";
export const highestSupportedNote = "B6";

export { SteinwayPiano };
